'use client';

import { SITE_URL } from '@/lib/site';
import Link from 'next/link';
import { ChevronRightIcon, HomeIcon } from '@heroicons/react/24/solid';
import { memo } from 'react';

interface BreadcrumbItem {
  label: string;
  href: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

// React.memo ile gereksiz render'ları önlüyoruz
export const Breadcrumb = memo(function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="Sayfa konumu" className="flex items-center flex-wrap gap-x-1 gap-y-2 text-sm text-gray-700">
      <Link href="/" className="hover:text-primary transition-colors min-h-[44px] min-w-[44px] inline-flex items-center justify-center focus:outline-none focus:ring-2 focus:ring-primary/20 rounded-md" aria-label="Ana sayfa">
        <HomeIcon className="h-4 w-4" aria-hidden />
      </Link>
      
      {items.map((item, index) => (
        <div key={item.href} className="flex items-center">
          <ChevronRightIcon className="h-3 w-3 mx-1 flex-shrink-0 text-gray-600" aria-hidden />
          {index === items.length - 1 ? (
            <span className="text-gray-900 font-medium" aria-current="page">{item.label}</span>
          ) : (
            <Link 
              href={item.href} 
              className="hover:text-primary transition-colors min-h-[44px] inline-flex items-center px-1 focus:outline-none focus:ring-2 focus:ring-primary/20 rounded-md text-gray-800"
            >
              {item.label}
            </Link>
          )}
        </div>
      ))}
    </nav>
  );
});

// JSON-LD yapılandırılmış veri oluşturan yardımcı fonksiyon
export function generateBreadcrumbJsonLd(items: BreadcrumbItem[]) {
  const breadcrumbItems = [
    {
      '@type': 'ListItem',
      'position': 1,
      'name': 'Ana Sayfa',
      'item': SITE_URL
    },
    ...items.map((item, index) => ({
      '@type': 'ListItem',
      'position': index + 2,
      'name': item.label,
      'item': `${SITE_URL}${item.href}`
    }))
  ];

  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    'itemListElement': breadcrumbItems
  };
} 